import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'VideoTheater_v2' */ './VideoTheater'),
  loading: () => null,
});

export default class WithVideoTheater extends React.Component {
  render() {
    const { isWapView } = this.props;
    if (!isWapView) {
      return <LoadableComponent {...this.props} />;
    }
    return null;
  }
}
